<template>
    <div class="job-page">
      <!-- 部门下拉选择 -->
      <div class="select-box">
        <el-select 
          v-model="selectedDept" 
          placeholder="请选择部门" 
          clearable
        >
          <el-option label="全部部门" value="" />
          <el-option label="集团总部" value="head" />
          <el-option label="武汉港务集团" value="wh" />
          <el-option label="宜昌港务集团" value="yc" />
        </el-select>
      </div>
  
      <!-- 岗位列表 → PC 2列 / 移动端 1列 -->
      <div class="job-list">
        <div class="job-item" v-for="job in filteredJobs" :key="job.id">
          <div class="job-name">{{ job.name }}</div>
          <div class="job-dept">{{ job.deptName }}</div>
          <div class="job-desc">{{ job.desc }}</div>
        </div>
  
        <div class="empty" v-if="filteredJobs.length === 0">
          该部门暂无招聘岗位
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "TabJob",
    data() {
      return {
        selectedDept: "",
        jobList: [
          { id: 1, name: "人力资源专员", dept: "head", deptName: "集团总部", desc: "负责招聘、培训、薪酬绩效等工作" },
          { id: 2, name: "财务会计", dept: "head", deptName: "集团总部", desc: "负责账务处理、报表编制、税务申报" },
          { id: 3, name: "运营管理岗", dept: "wh", deptName: "武汉港务集团", desc: "负责港口生产运营、调度管理" },
          { id: 4, name: "安全环保岗", dept: "wh", deptName: "武汉港务集团", desc: "负责安全管理、环境监督、隐患排查" },
          { id: 5, name: "工程技术岗", dept: "yc", deptName: "宜昌港务集团", desc: "负责设备维护、工程管理、技术改造" },
          { id: 6, name: "市场营销岗", dept: "yc", deptName: "宜昌港务集团", desc: "负责市场开发、客户维护、业务拓展" },
        ]
      };
    },
    computed: {
      filteredJobs() {
        if (!this.selectedDept) return this.jobList;
        return this.jobList.filter(item => item.dept === this.selectedDept);
      }
    }
  };
  </script>
  
  <style scoped lang="less">
  .job-page {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px 15px;
    box-sizing: border-box;
  }
  
  /* 下拉框样式 */
  .select-box {
    text-align: center;
    margin-bottom: 30px;
  
    /deep/ .el-select {
      width: 100%;
      max-width: 320px;
    }
  
    /deep/ .el-input__inner {
      height: 44px;
      border-radius: 8px;
      border: 1px solid #dcdfe6;
      font-size: 15px;
    }
  }
  
  /* =========================
     PC 端 → 一行两列布局
  ========================= */
  .job-list {
    display: grid;
    grid-template-columns: repeat(2, 1fr); /* 固定 2 列 */
    gap: 20px; /* 间距 */
    width: 100%;
  }
  
  .job-item {
    background: #fff;
    padding: 24px;
    border-radius: 12px;
    box-shadow: 0 2px 10px rgba(0, 86, 179, 0.06);
    border-left: 4px solid #0056b3;
    transition: transform 0.2s;
  }
  
  .job-item:hover {
    transform: translateY(-3px);
  }
  
  .job-name {
    font-size: 17px;
    font-weight: bold;
    color: #0056b3;
    margin-bottom: 6px;
  }
  
  .job-dept {
    font-size: 14px;
    color: #666;
    margin-bottom: 8px;
  }
  
  .job-desc {
    font-size: 14px;
    color: #333;
    line-height: 1.6;
  }
  
  /* 空数据铺满 */
  .empty {
    grid-column: 1 / -1;
    text-align: center;
    color: #999;
    padding: 50px 0;
  }
  
  /* =========================
     移动端 → 自动变成 1 列
  ========================= */
  @media (max-width: 768px) {
    .job-list {
      grid-template-columns: 1fr;
    }
    .job-item {
      padding: 18px;
    }
  }
  </style>